import { render, staticRenderFns } from "./yikuForm.vue?vue&type=template&id=d3955f3e&scoped=true&"
import script from "./yikuForm.vue?vue&type=script&lang=js&"
export * from "./yikuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3955f3e",
  null
  
)

export default component.exports